export const html = "<p>Weave on a traditional Armenian carpet loom.</p>\n";
export const leadHtml = "<p>Weave on a traditional Armenian carpet loom.</p>\n";
export const bodyHtml = "";
export const metaText = "Weave on a traditional Armenian carpet loom.";